// INMA-301: Utilidades de suscripción Stripe
import { getSubscriptionDetail } from "./data/subscriptions";

export type PlanId = "none" | "basic" | "equipo" | "pro" | "enterprise";

export interface Subscription {
  plan_id: PlanId;
  status: string;
  current_period_end: string | null;
  cancel_at_period_end: boolean;
  stripe_customer_id: string | null;
}

export async function getSubscription(userId: string): Promise<Subscription | null> {
  const { data } = await getSubscriptionDetail(userId);
  return (data as Subscription | null) ?? null;
}

export function isSubscriptionActive(sub: Subscription | null): boolean {
  return sub != null && ["active", "trialing"].includes(sub.status);
}

export function canAccessFeature(sub: Subscription | null, requiredPlan: PlanId): boolean {
  if (!isSubscriptionActive(sub)) return false;
  const levels: Record<PlanId, number> = { none: 0, basic: 1, equipo: 2, pro: 3, enterprise: 4 };
  return (levels[sub!.plan_id] ?? 0) >= (levels[requiredPlan] ?? 0);
}

import { postToFunction } from "./data/functions";

export async function createCheckoutSession(
  token: string,
  type: "subscription",
  planId: string
): Promise<string>;
export async function createCheckoutSession(
  token: string,
  type: "one_time",
  productId: string
): Promise<string>;
export async function createCheckoutSession(
  token: string,
  type: "subscription" | "one_time",
  id: string
): Promise<string> {
  const body = type === "subscription"
    ? { type, planId: id }
    : { type, productId: id };

  const { url } = await postToFunction<{ url: string }>("stripe-checkout", {
    body,
    token,
    fallback: "Error al crear sesión de pago",
  });
  return url;
}

export async function openCustomerPortal(token: string): Promise<string> {
  const { url } = await postToFunction<{ url: string }>("stripe-portal", {
    token,
    fallback: "Error al abrir portal",
  });
  return url;
}
